import React from 'react';
import { useForm, ValidationError } from '@formspree/react';

function Contact() {
  const [state, handleSubmit] = useForm("xvolazrb");

  if (state.succeeded) {
    return (
      <div id="contact" className="container status">
        <h3>Your message has been sent!</h3>
        <a className="return" href="/#contact">Return</a>
      </div>
    );
  }

  return (
    <div id="contact" className="container">
      <h1>Let's Connect</h1>
      <div className="form">
        <form onSubmit={handleSubmit}>
          <label htmlFor="email"></label>
          <input
            id="email"
            type="email"
            name="email"
            placeholder="johndoe@example.com"
            required
          />
          <ValidationError prefix="Email" field="email" errors={state.errors} />
          <textarea
            id="message"
            name="message"
            placeholder="Your Message Here"
            required
          />
          <ValidationError prefix="Message" field="message" errors={state.errors} />
          <button type="submit" disabled={state.submitting}>Submit</button>
          

        </form>
      </div>
    </div>
  );
}

export default Contact;
